var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWhiteX(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "41px",
    height: "42px",
    viewBox: "0 0 41 42",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 4") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    fill: "#ffffff"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    transform: "translate(20.500000, 21.000000) rotate(45.000000) translate(-20.500000, -21.000000) ",
    x: -6,
    y: 19,
    width: 53,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    transform: "translate(20.500000, 21.000000) rotate(-45.000000) translate(-20.500000, -21.000000) ",
    x: -6,
    y: 19,
    width: 53,
    height: 4
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteX);
export default __webpack_public_path__ + "static/media/white-x.519b20b484cb3befee83b6c9b23e44a5.svg";
export { ForwardRef as ReactComponent };